if (!customElements.get('ka-strap-upsell')) {
  customElements.define('ka-strap-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const init = () => this.setup();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
      else init();
    }
    setup() {
      this.config = JSON.parse(this.querySelector('[data-strap-config]').textContent);
      this.scope = this.closest('.product-section') || this.closest('[data-section-id]')?.parentElement;
      this.form = this.scope?.querySelector('form.product-single__form') || document.getElementById('AddToCartForm-' + this.dataset.sectionId);
      if (!this.form || !('FormDataEvent' in window)) {
        this.querySelectorAll('input').forEach(input => input.disabled = true);
        this.querySelector('[data-strap-fallback]').hidden = false;
        return;
      }
      this.querySelector('fieldset').disabled = false;
      this.buttonText = this.form.querySelector('[data-add-to-cart-text]');
      this.defaultText = this.buttonText?.textContent.trim() || '';
      this.querySelectorAll('input').forEach(input => input.addEventListener('change', () => this.paint()));
      this.form.addEventListener('formdata', event => this.addStrap(event.formData));
      this.form.addEventListener('change', () => this.paint());
      this.scope.addEventListener('variant:change', () => this.paint());
      this.form.addEventListener('ajaxProduct:added', () => {
        const none = this.querySelector('input[value=""]');
        if (none) none.checked = true;
        this.paint();
      });
      this.paint();
    }
    selection() { return this.querySelector('input:checked:not(:disabled)'); }
    mainVariant() {
      const id = this.form.querySelector('[name="id"]')?.value;
      return this.config.variants.find(variant => String(variant.id) === String(id));
    }
    quantity() { return Math.max(1, Number(this.form.querySelector('[name="quantity"]')?.value) || 1); }
    paint() {
      const chosen = this.selection();
      const main = this.mainVariant();
      if (chosen?.value && main?.available) {
        if (this.buttonText) this.buttonText.textContent = this.config.addLabel;
      } else {
        if (this.buttonText && main?.available) this.buttonText.textContent = this.defaultText;
      }
    }
    addStrap(data) {
      const chosen = this.selection();
      if (!chosen?.value) return;
      const id = data.get('id');
      if (!id || !this.mainVariant()?.available) return;
      const qty = String(this.quantity());
      const entries = Array.from(data.entries());
      for (const [key, value] of entries) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan' || /^properties\[.+\]$/.test(key)) {
          data.delete(key);
          data.append('items[0][' + key.replace(/^properties\[(.+)\]$/, 'properties][$1') + ']', value);
        }
      }
      data.set('items[0][quantity]', qty);
      data.set('items[1][id]', chosen.value);
      data.set('items[1][quantity]', qty);
      data.set('items[1][properties][_ka_strap_parent_variant]', String(id));
      data.set('items[1][properties][' + this.config.strapLabel + ']', this.config.parentTitle);
      const serviceId = data.get('items[0][properties][_ka_service_id]');
      if (serviceId) data.set('items[1][properties][_ka_strap_parent_service_id]', serviceId);
    }
  });
}
